import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HolderOutlined } from '@ant-design/icons';

interface SortableItemProps {
  id: string;
  content: React.ReactNode;
}

const SortableItem: React.FC<SortableItemProps> = ({ id, content }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    // Positioning and transitions
    transform: CSS.Transform.toString(transform),
    transition,

    // Layout and spacing
    padding: '12px 20px',
    margin: '7px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    // Visuals (default state)
    backgroundColor: 'white',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    color: '#333',
    fontSize: '1em',
    cursor: 'grab',

    // Visuals (dragging state)
    zIndex: isDragging ? 10 : 'auto',
    opacity: isDragging ? 0.9 : 1,
    boxShadow: isDragging
      ? '0 8px 20px rgba(0, 0, 0, 0.2)'
      : '0 2px 5px rgba(0, 0, 0, 0.05)',
    borderColor: isDragging ? '#007bff' : '#e0e0e0',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <span style={{ color: '#888' }}>
        <HolderOutlined />
      </span>
      {content}
    </div>
  );
};

export default SortableItem;